import type { ClientOrgContextKey } from '@provider-directory/types/organizations.contracts';

const warnedUnresolvableDirectoryDisplayName = new Set<ClientOrgContextKey>();

/**
 * Looks up a sibling display name from `directoryDisplayNames`.
 * On miss: warn once, then return `fallbackName` (active directory name for
 * associations per DIR-3545 AC; empty string for filter labels so a missing
 * seed is not hidden behind local hardcode).
 */
export const resolveDirectoryDisplayName = (
  key: ClientOrgContextKey,
  directoryDisplayNames:
    | Partial<Record<ClientOrgContextKey, string>>
    | undefined,
  fallbackName = '',
): string => {
  const name = directoryDisplayNames?.[key];
  if (name !== undefined) {
    return name;
  }
  if (!warnedUnresolvableDirectoryDisplayName.has(key)) {
    warnedUnresolvableDirectoryDisplayName.add(key);
    console.warn(
      `[OrgContext] directoryDisplayNames has no entry for "${key}"` +
        (fallbackName.length > 0
          ? `; falling back to "${fallbackName}"`
          : ' (no fallback)'),
    );
  }
  return fallbackName;
};

/** Test-only: reset the once-per-key warn set. */
export const resetDirectoryDisplayNameWarnCacheForTests = (): void => {
  warnedUnresolvableDirectoryDisplayName.clear();
};
